module.exports = __webpack_public_path__ + "static/02-90ba068de17a93fc5ed14a9eb6332ff2.jpg";